import { withInstall } from '@vuesax-plus/utils'

import Icon from './src/icon.vue'

export const VsIcon = withInstall(Icon)
export default VsIcon

export * from './src/icon'
